import { getConfig } from '@ionic/react'
import { useEffect } from 'react'

/**
 * Turns Ionic's global `swipeBackEnabled` off while the caller (the tab
 * shell) is mounted and restores the previous value on unmount. Ionic reads
 * the config per gesture and has no per-outlet switch.
 * Why: docs/adr/0009-ghost-tab-roots-in-outlet.md
 */
export const useNativeSwipeBackOff = () => {
  useEffect(() => {
    const config = getConfig()
    if (!config) return
    const previous = config.get('swipeBackEnabled')
    config.set('swipeBackEnabled', false)
    return () => config.set('swipeBackEnabled', previous)
  }, [])
}
